export default __webpack_public_path__ + "static/media/payment_success.53fe6805.svg";